import { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Layout from '../components/Layout'
import PagnationComponent from '../components/PagnationComponent'
import { Container, Typography } from '@mui/material'
import { getAllProductColors } from '../store/actions/productColorAction'
import { CHANGE_PRODUCT_COLORS_PAGE } from '../store/types'
import SearchProductColors from '../components/productColor/SearchProductColors'
import ProductColorInfo from '../components/productColor/ProductColorInfo'
import ProductColorDownload from '../components/productColor/ProductColorDownload'

const ProductColors = () => {
    const dispatch = useDispatch()
    const { productColors, pages, page, count, keyword } = useSelector(
        (state) => state.productColor
    )

    const pageNumber = page || 1
    useEffect(() => {
        dispatch(getAllProductColors(keyword, pageNumber))
    }, [dispatch, keyword, pageNumber])

    const changePage = useCallback(
        (page) => {
            dispatch({ type: CHANGE_PRODUCT_COLORS_PAGE, payload: page })
        },
        [dispatch]
    )
    return (
        <Layout>
            <Container>
                <ProductColorDownload />
                <SearchProductColors displayKeyword={keyword} />
                <Typography
                    variant="body2"
                    gutterBottom
                    style={{ paddingBottom: '10px', paddingTop: '10px' }}
                >
                    Count: {count}
                </Typography>
                {productColors && (
                    <ProductColorInfo productColors={productColors} />
                )}
                <PagnationComponent
                    page={pageNumber}
                    pages={pages}
                    func={changePage}
                />
            </Container>
        </Layout>
    )
}

export default ProductColors
